import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BUSINESS_TRIP_GET_LIST_STORE_NAME, BusinessTripGetListState } from './business-trip-get-list.state';

/** Select BusinessTripGetList State */
export const selectBusinessTripGetListState = createFeatureSelector<BusinessTripGetListState>(
  BUSINESS_TRIP_GET_LIST_STORE_NAME
);

/** Select BusinessTripGetList isPending status */
export const selectBusinessTripGetListIsPendingStatus = createSelector(
  selectBusinessTripGetListState,
  (state) => !!state.isPending
);

/** Select BusinessTripGetList isFailure status */
export const selectBusinessTripGetListIsFailureStatus = createSelector(
  selectBusinessTripGetListState,
  (state) => !!state.isFailure
);
